export default "__VITE_ASSET__a48a6352__"